import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCoQYearData } from 'services/glass-management/glassManagement';

export const fetchCoqYear = createAsyncThunk('glass/coqyear/fetch', async () => {
    const res = await getCoQYearData();
    return { data: res };
});

export const coqYearSlice = createSlice({
    name: 'glassCoqYear',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCoqYear.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCoqYear.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchCoqYear.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load CoQ Yearly Summary';
                state.data = null;
            });
    }
});

export default coqYearSlice.reducer;
